import { createElement, Fragment } from 'react';
import { oneOf, bool, oneOfType, func, node, string } from 'prop-types';
import { animatePropTypes, restrictHidePropTypes, animateDefaultProps, restrictDefaultProps } from './types/props.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Portal from './Portal/index.js';
import Backdrop from './Backdrop/index.js';
import { a as isFunction } from './chunk-5c9bbccf.js';
import { a as TrapFocus } from './chunk-abb87050.js';
import SidebarContainer from './Sidebar/SidebarContainer.js';
import _Sidebar from './Sidebar/styled.js';
import SidebarClose from './Sidebar/SidebarClose.js';
import SidebarHide from './Sidebar/SidebarHide.js';
import SidebarShow from './Sidebar/SidebarShow.js';

var Sidebar = function Sidebar(_ref) {
  var align = _ref.align,
      backdropFade = _ref.backdropFade,
      children = _ref.children,
      delay = _ref.delay,
      duration = _ref.duration,
      fade = _ref.fade,
      hide = _ref.hide,
      hideCloseButton = _ref.hideCloseButton,
      hideOnEsc = _ref.hideOnEsc,
      hideOnClickOutside = _ref.hideOnClickOutside,
      isVisible = _ref.isVisible,
      onClickClose = _ref.onClickClose,
      slide = _ref.slide,
      width = _ref.width,
      props = _objectWithoutPropertiesLoose(_ref, ["align", "backdropFade", "children", "delay", "duration", "fade", "hide", "hideCloseButton", "hideOnEsc", "hideOnClickOutside", "isVisible", "onClickClose", "slide", "width"]);

  return createElement(Portal, null, createElement(TrapFocus, {
    delayToActivate: fade || slide ? duration : undefined,
    isActive: isVisible,
    usesPortal: true
  }, function (_ref2) {
    var fallbackFocusRef = _ref2.fallbackFocusRef,
        initialFocusRef = _ref2.initialFocusRef;
    return createElement(Fragment, null, createElement(Backdrop, {
      delay: delay,
      duration: duration,
      hide: hide,
      fade: backdropFade,
      hideOnEsc: hideOnEsc,
      isVisible: isVisible,
      use: hideOnClickOutside ? SidebarHide : undefined,
      expand: undefined,
      slide: undefined
    }), createElement(Box, {
      elementRef: fallbackFocusRef
    }, createElement(_Sidebar, _extends({
      "aria-modal": "true",
      align: align,
      delay: delay,
      duration: duration,
      fade: fade,
      hideOnEsc: hideOnEsc,
      hideOnClickOutside: hideOnClickOutside,
      slide: slide,
      width: width
    }, props, {
      // @ts-ignore
      visible: isVisible || props.visible
    }), !hideCloseButton && // @ts-ignore
    createElement(SidebarClose, {
      use: SidebarHide,
      elementRef: initialFocusRef,
      hide: hide,
      onClick: onClickClose,
      palette: "white",
      sidebarAlign: align,
      sidebarWidth: width
    }), isFunction(children) ? children({
      initialFocusRef: initialFocusRef
    }) : children)));
  }));
};
var sidebarPropTypes = _objectSpread({
  align: oneOf(['left', 'right']),
  backdropFade: bool,
  children: oneOfType([func, node]),
  className: string,
  isVisible: bool,
  hide: func,
  hideCloseButton: bool,
  onClickClose: func,
  width: string
}, animatePropTypes, restrictHidePropTypes);
Sidebar.propTypes = sidebarPropTypes;
var sidebarDefaultProps = _objectSpread({}, animateDefaultProps, restrictDefaultProps, {
  align: 'left',
  backdropFade: true,
  className: undefined,
  duration: '0.2s',
  hideCloseButton: false,
  hideOnClickOutside: true,
  hideOnEsc: true,
  isVisible: false,
  onClickClose: undefined,
  slide: true,
  width: '250px'
});
Sidebar.defaultProps = sidebarDefaultProps;
Sidebar.Container = SidebarContainer;
Sidebar.Close = SidebarClose;
Sidebar.Hide = SidebarHide;
Sidebar.Show = SidebarShow;
var C = Sidebar;

export { C as a, sidebarPropTypes as b, sidebarDefaultProps as c };
